module.exports = __webpack_public_path__ + "media/src/images/webclip-ac4422760b3b3d392a837262285b3866.png";